import envvars from 'utils/envvars';

export const getApiBaseUrl = () => (
  process.env.NODE_ENV === 'production'
    ? `${envvars.apiServer}/v1`
    : '/v1'
);

export const getUserProfilePictureUrl = (
  userId: string,
  cacheKey?: string | Date,
) => {
  const url = `${getApiBaseUrl()}/users/${userId}/picture`;
  if (!cacheKey) {
    return url;
  }
  const timestamp = cacheKey instanceof Date
    ? cacheKey.getTime()
    : new Date(cacheKey).getTime();
  if (Number.isNaN(timestamp)) {
    return url;
  }
  return `${url}?t=${timestamp}`;
};
